import { Card, Col, Progress, Row } from 'antd';
import React from 'react';
import {
  KpiFlightDate,
  KpiSubText,
  KPITitleText,
} from '../../../../../../../shared/globalStyling/styledText';
import { ExtraInfo } from '../../../attribution/components';
import { ArrowRightOutlined } from '@ant-design/icons';
import {
  formatNumber2SigFig,
  formatWholeNumber,
} from '../../../../../../../../core/utils/campaigns';
import moment from 'moment';

const styles = {
  container: {
    backgroundColor: '#fff',
    borderTop: 'solid 1px #e8e8e8',
    marginBottom: '1%',
  },
  secondaryContainer: {
    padding: '3% 3% 1% 3%',
    margin: 0,
  },
  title: {
    marginBottom: '10px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  flightContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '35%',
    borderLeft: 'solid 1px #e8e8e8',
    padding: '3% 3% 1% 3%',
    margin: 0,
  },
  datesContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  dates: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  keyColors: {
    spent: '#1665d8',
    remaining: '#34aa44',
    budget: '#030303',
    total: '#bec0c3',
    value: '#99999',
  },
  overflow: {
    height: '70px',
    overflow: 'auto',
  },
};

const LineItemsDetailBar = ({ startDate, endDate, impressions, clicks, ctr }) => {
  const getProgress = () => {
    const total = () => {
      var a = moment(endDate);
      var b = moment(startDate);
      const total = a.diff(b, 'days');
      return total;
    };

    const progress = () => {
      var a = moment();
      var b = moment(startDate);
      const progress = a.diff(b, 'days');
      return progress;
    };

    const totaldays = total();
    const progressDays = progress();
    if (progressDays > totaldays || progressDays === totaldays) {
      return 100;
    }

    // % increase = Increase ÷ Original Number × 100.
    const daysleft = totaldays - progressDays;
    const daysin = totaldays - daysleft;
    const result = (daysin / totaldays) * 100;
    return Math.floor(result);
  };
  const currentposition = getProgress();
  return (
    <Row style={styles.container} type="flex">
      <Col xl={6} lg={6} md={12} xs={24}>
        <Card style={{ height: '10em', borderLeft: 0, borderTop: 0 }} bodyStyle={{ borderLeft: 0 }}>
          <div style={styles.title}>
            <KPITitleText text={'Flight Dates'} />
            <span>
              <ExtraInfo
                title={'Flight Dates refers to the Start & End Dates of the individual campaign'}
                placement={'top'}
              />
            </span>
          </div>
          <div style={styles.datesContainer}>
            <div style={styles.dates}>
              <KpiFlightDate text={startDate ? moment(startDate).format('MM/DD/YYYY') : ''} />
            </div>
            <div>
              <ArrowRightOutlined style={{ color: '#636363' }} />
            </div>
            <div style={styles.dates}>
              <KpiFlightDate text={endDate ? moment(endDate).format('MM/DD/YYYY') : ''} />
            </div>
          </div>
          <Progress
            showInfo={false}
            percent={currentposition}
            status={currentposition !== 100 ? 'active' : 'normal'}
            strokeColor={'#636363'}
          />
        </Card>
      </Col>
      <Col xl={6} lg={6} md={12} xs={24}>
        <Card style={{ height: '10em', borderLeft: 0, borderTop: 0 }} bodyStyle={{ borderLeft: 0 }}>
          <div style={styles.title}>
            <KPITitleText text={'Impressions'} />
          </div>
          <KpiSubText text={formatWholeNumber(impressions)} />
        </Card>
      </Col>
      <Col xl={6} lg={6} md={12} xs={24}>
        <Card style={{ height: '10em', borderLeft: 0, borderTop: 0 }} bodyStyle={{ borderLeft: 0 }}>
          <div style={styles.title}>
            <KPITitleText text={'Clicks'} />
          </div>
          <KpiSubText text={formatWholeNumber(clicks)} />
        </Card>
      </Col>
      <Col xl={6} lg={6} md={12} xs={24}>
        <Card style={{ height: '10em', borderLeft: 0, borderTop: 0 }} bodyStyle={{ borderLeft: 0 }}>
          <div style={styles.title}>
            <KPITitleText text={'CTR'} />
          </div>
          <KpiSubText text={formatNumber2SigFig(ctr) + '%'} />
        </Card>
      </Col>
    </Row>
  );
};

export default LineItemsDetailBar;
